import * as React from 'react';
export const visaSvg = React.forwardRef(function visaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.772 10.428H5.506l.792-4.84h1.265l-.791 4.84Zm4.588-4.722a3.152 3.152 0 0 0-1.135-.206c-1.25 0-2.13.659-2.136 1.601-.01.695.63 1.082 1.11 1.313.49.237.656.392.656.603-.005.324-.396.474-.76.474-.506 0-.776-.077-1.188-.258l-.167-.077-.177 1.086c.297.134.844.253 1.412.258 1.328 0 2.193-.649 2.203-1.653.005-.55-.333-.973-1.062-1.318-.443-.222-.714-.37-.714-.598.005-.205.23-.416.729-.416.412-.01.714.087.943.185l.114.051.173-1.045Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.626 5.588h.98l1.02 4.84h-1.171l-.151-.726h-1.626l-.265.726h-1.329l1.88-4.439c.131-.314.36-.401.662-.401Zm-.078 1.771s-.4 1.076-.505 1.354h1.052c-.052-.242-.292-1.4-.292-1.4l-.088-.417c-.037.107-.091.255-.127.354l-.04.109Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm4.448 5.588-1.24 3.3-.135-.67c-.229-.772-.948-1.61-1.75-2.028l1.136 4.233h1.338l1.99-4.835H4.448Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.058 5.588H.02L0 5.686c1.589.401 2.64 1.37 3.073 2.533L2.63 5.995c-.072-.31-.296-.397-.572-.407Z',
    }),
  );
});
visaSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var visa = {
  category: 'paymentmethod',
  colorable: true,
  name: 'visa',
  svg: visaSvg,
};
